import { LiquidationBanner as BaseLiquidationBanner } from '@silo/ui';
import { useQueryDashboardData } from '../dashboard/use-query-dashboard-data';
import { getMarketsAtRiskOfLiquidation } from '../dashboard/utils';

interface LiquidationBannerProps {
  href: string;
}

export function LiquidationBanner({ href }: LiquidationBannerProps): JSX.Element | null {
  const { data } = useQueryDashboardData();
  const marketsAtRiskOfLiquidation = getMarketsAtRiskOfLiquidation(data);

  if (marketsAtRiskOfLiquidation === 0) {
    return null;
  }

  return <BaseLiquidationBanner marketsAtRiskOfLiquidation={marketsAtRiskOfLiquidation} href={href} />;
}
